



















import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import TxTableHead from '@/components/rows/TxRow/TxTableHead.vue'
import TxRow from '@/components/rows/TxRow/TxRow.vue'
import { Transaction } from '@/js/Transaction'

@Component({
    components: {
        TxTableHead,
        TxRow,
    },
})
export default class TxInteractive extends Vue {
    @Prop() transactions!: Transaction[]
}
